/* global $ */

import formatPrice from '../helpers/formatPrice';

const $data = $('.js-data');
const $deliveryAddress = $('.js-delivery-address');
const $invoiceAddress = $('.js-invoice-address');
const $invoiceToggle: JQuery<HTMLElement> = $('.js-invoice-toggle');

const data = {
  initialize() {
    if ($data.length) {
      this.forms = {
        desktop: $('#desktop-form').html(),
        mobile: $('#mobile-form').html(),
      };

      this.createListeners();
      this.checkInvoice();
    }
  },

  createListeners() {
    $data.on('change keyup', 'input', () => {
      this.recalculate();
    });

    $data.on('change', '.js-delivery-option', (e: any) => {
      const $option = $(e.currentTarget);
      const price: number = parseFloat($option.data('price'));
      $('.js-delivery-hidden').val(price);

      this.recalculate();
      this.checkDeliver();
      this.renumber();
    });

    $invoiceToggle.on('change', () => {
      this.checkInvoice();
      this.renumber();
    });

    $(document).on('cart:recalculate', () => {
      this.recalculate();
    });
  },

  checkDeliver() {
    const $checkedDeliveryMethod: any = $('.js-delivery-option:checked');
    const identifier: string = $checkedDeliveryMethod.data('identifier');

    $deliveryAddress.toggle(identifier === 'deliver');

    if (identifier === 'pickup') {
      $invoiceAddress.hide();
    } else {
      this.checkInvoice();
    }
  },

  checkInvoice() {
    const checkboxNode: any = $invoiceToggle[0];
    $invoiceAddress.toggle(checkboxNode.checked);
  },

  recalculate() {
    const subTotalInput: any = $('.js-products-hidden');
    const deliveryInput: any = $('.js-delivery-hidden');
    const discountInput: any = $('.js-discount-hidden');

    const subTotal = parseFloat(subTotalInput.val());
    const delivery = parseFloat(deliveryInput.val());
    const discount = parseFloat(discountInput.val());

    const total: number = (subTotal + delivery) - discount;

    $('.js-products-subtotal').html(formatPrice(subTotal));
    $('.js-products-delivery').html(formatPrice(delivery));
    $('.js-products-discount').html(`- ${formatPrice(discount)}`);
    $('.js-discount-row').toggle(discount > 0);
    $('.js-products-total').html(formatPrice(total > 0 ? total : 0));
  },

  renumber() {
    const $plates = $('.step-plate:visible');

    $plates.toArray().forEach((plate: HTMLElement, index: number) => {
      const $plate = $(plate);
      $plate.find('.step-plate__number').text(index + 1);
      $plate.find('.step-plate__total').text($plates.length);
    });
  },
};

export default data;
